import { render, staticRenderFns } from "./ContactTakeIn.vue?vue&type=template&id=551f68f9&"
import script from "./ContactTakeIn.vue?vue&type=script&lang=js&"
export * from "./ContactTakeIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports